import StandaloneLayout from "./layout"
import TopbarPlugin from "plugins/topbar"
import ConfigsPlugin from "corePlugins/configs"
import ThinkhrPlugin from "plugins/thinkhr"
// the Standalone preset

let preset = [
  TopbarPlugin,
  ConfigsPlugin,
  ThinkhrPlugin,
  () => {
    return {
      components: { StandaloneLayout }
    }
  }
]

module.exports = preset



// WEBPACK FOOTER //
// ./src/standalone/index.js